<template>
    <div style="height: 100vh; overflow: auto; border: 1px solid #ccc;">
        <img style="width: 100%; display: block;"
            src="http://yunlei-rabbit-hn2.oss-cn-heyuan.aliyuncs.com/2025/4/8/1909583343925133313.jpg" />
    </div>
</template>